import View from "../framework/view";
import template from "../../pugc/library";
import {Recording} from "../bo/recording";
import Server from "../server";
import LocalDB from "../misc/localdb";
import {isInViewport, tweakRecording} from "../misc/utils";

const INITIAL_RENDER_TO = 30;

let scrollhandler : any = undefined;

jQuery(document).on("scroll", (event) => {
    scrollhandler && scrollhandler(event);
});

export default class LibraryView extends View {

    static classname = "library-view";

    private server = Server.instance();

    private recordings : Recording[] | undefined;

    private filtered : Recording[] | undefined;

    private libraries : string[] = [];

    private library : string = LocalDB.instance().get("library") || "TALC";

    private filter : string = "";

    private renderTo : number = INITIAL_RENDER_TO;

    constructor() {
        super(LibraryView.classname);

        this.server.fetchLibraries().then(libs => {
            this.libraries = libs;
            let library = this.library;
            if (libs.indexOf(this.library) == -1 && libs.length > 0) {
                library = libs[0];
            }
            this.setLibrary(library);
            this.update();
        });

    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            recordings: (this.filtered ||[]).slice(0, this.renderTo),
            library: this.library,
            libraries: this.libraries,
            filter: this.filter,
        };

        const out= this.pug(template, data);

        scrollhandler = (event: any) => this.scroll(event);

        return out;
    }

    private scroll(event: any) {

        scrollhandler = undefined;

        const elt = this.elt();

        if (! elt) {
            return;
        }

        const infinite = elt.find(".infinite");

        if (isInViewport(infinite)) {

            const page = INITIAL_RENDER_TO;
            const recordings = (this.filtered || []).slice(this.renderTo, this.renderTo + page);

            const items = this.renderSlice(recordings);

            items.insertBefore(infinite);
            if (items.length == 0) {
                infinite.remove();
            }

            this.renderTo += INITIAL_RENDER_TO;
        }

        scrollhandler = (event: any) => this.scroll(event);
    }

    private renderSlice(recordings: Recording[]) {
        const data = {
            recordings: recordings,
            library: this.library,
            libraries: this.libraries,
            filter: this.filter,
        };

        const out = this.pug(template, data);
        const items = out.find(".tracks li");
        return items;
    }

    setLibrary(lib: string) {
        this.library = lib;
        LocalDB.instance().set("library", this.library);

        this.server.fetchRecordings(this.library).then((recordings) => {
            this.recordings = recordings;
            this.recordings.forEach(r => tweakRecording(r));
            this.setFilter(this.filter);
            this.update();
        });
    }

    setFilter(f0: string) {
        f0 = (f0 || "").trim();

        if (this.filter !== f0) {
            this.renderTo = INITIAL_RENDER_TO;
        }

        this.filter = f0;

        const f= (this.filter || "").toLowerCase();

        this.filtered = (this.recordings || []).filter(r => {
            if (! f) {
                return true;
            }
            const a : any = r;
            if (! a.json) {
                a.json = JSON.stringify(r).toLowerCase();
            }
            return a.json.indexOf(f) > -1;
        });

        this.update(".tracks");
    }

    autoplay() {
        if (! this.recordings) {
            return;
        }
        const idx = Math.floor(Math.random() * this.recordings.length);
        const id = this.recordings[idx].id;
        const url = `#/player/${id}/autoplay`;
        window.location.href = url;
    }
}

View.on(
    "." + LibraryView.classname,
    "change",
    "select.library",
    function(that: LibraryView, event, elt) {
        event.preventDefault();
        const lib = jQuery(elt).val() as string;
        that.setLibrary(lib);
    });

View.on(
    "." + LibraryView.classname,
    "input",
    "input.filter",
    function(that: LibraryView, event, elt) {
        event.preventDefault();
        const f = jQuery(elt).val() as string;
        that.setFilter(f);
    });

View.on(
    "." + LibraryView.classname,
    "click",
    ".autoplay",
    function(that: LibraryView, event, elt) {
        event.preventDefault();
        that.autoplay();
    });

